/* eslint-disable no-shadow */
import React, { useContext, useEffect } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { setSelectedCoreISODate, setSelectedCoreSeats } from '../../../../../ui-kitchen/src/reducers/resyCoreSlice';
import { getVenue, handleReservationCancel } from '../../../../../ui-kitchen/src/api/api';
import ConfirmationPage from './ConfirmationPage';
import PathBuilderContext from '../WidgetApp/PathBuilderContext';
import IframeHostContext from '../../contexts/iframeHost';
import reservationShape from './reservationShape';
import { selectIsAuthenticated } from '../../../../../ui-kitchen/src/reducers/authTokenSlice';
import getLocationSlug from '../../../../../ui-kitchen/src/utils/getLocationSlug';
import { setNavVenueName, setRouteEventPath } from '../../../../../ui-kitchen/src/reducers/resyRouterSlice';

const closeWidget = () => {
  window.parent.postMessage({
    event: 'close',
    value: true,
  }, '*');
};

const closeWindow = () => {
  window.close();
};

const ChangeCancelController = (props) => {
  const {
    Analytics,
    day,
    isAuthenticated,
    preferredLanguage,
    reservation,
    seats,
    setNavVenueName,
    setRouteEventPath,
    setSelectedCoreISODate,
    setSelectedCoreSeats,
    time,
    user,
  } = props;
  const pathBuilder = useContext(PathBuilderContext);
  const iframeHost = useContext(IframeHostContext);
  const navigate = useNavigate();
  useEffect(() => {
    const fetchEvent = () => getVenue({ id: reservation.venue.id })
      .then((venue) => {
        const locationSlug = getLocationSlug(venue.location);
        pathBuilder.setValues({
          addOnsTemplateId: undefined,
          eventPath: `/cities/${locationSlug}/venues/${venue.url_slug}/events/${reservation.event.eventUrlSlug}`,
          venueId: reservation.venue.id,
        });
        setRouteEventPath(pathBuilder.backPath());
      });

    /* istanbul ignore else */
    if (reservation?.event && reservation.event?.eventUrlSlug) {
      fetchEvent();
    }
  }, []);

  // exit early checks,
  // /account/reservations-and-notify is already an auth-gated route
  if (!isAuthenticated || typeof reservation === 'undefined') {
    navigate('/account/reservations-and-notify');
  }

  setSelectedCoreSeats(seats);
  setSelectedCoreISODate(day);
  const isModal = window.self !== window.top;
  setNavVenueName(reservation?.venue?.name);
  const viewPortHeight = iframeHost.getDimensions().innerHeight;
  pathBuilder.setValues({
    addOnsTemplateId: undefined,
    eventPath: undefined,
    venueId: reservation?.venue?.id,
  });
  pathBuilder.setSearch(seats, day);

  return (
    <ConfirmationPage
      Analytics={Analytics}
      cancel={handleReservationCancel}
      closeWidget={closeWidget}
      closeWindow={closeWindow}
      day={day}
      isModal={isModal}
      navigate={navigate}
      pathBuilder={pathBuilder}
      preferredLanguage={preferredLanguage}
      reservation={reservation}
      time={time}
      user={user}
      viewPortHeight={viewPortHeight}
    />
  );
};

ChangeCancelController.propTypes = {
  Analytics: PropTypes.shape({}).isRequired,
  day: PropTypes.string.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  preferredLanguage: PropTypes.string.isRequired,
  setNavVenueName: PropTypes.func.isRequired,
  setRouteEventPath: PropTypes.func.isRequired,
  setSelectedCoreISODate: PropTypes.func.isRequired,
  setSelectedCoreSeats: PropTypes.func.isRequired,
  reservation: reservationShape.isRequired,
  seats: PropTypes.number.isRequired,
  time: PropTypes.string.isRequired,
  user: PropTypes.shape({}).isRequired,
};

const mapStateToProps = (state) => {
  const { user } = state;
  const { reservationToBeModified: reservation } = user;
  return {
    isAuthenticated: selectIsAuthenticated(state),
    day: reservation?.day,
    seats: reservation?.seats,
    time: reservation?.time,
    reservation,
    user,
  };
};

const mapDispatchToProps = {
  setNavVenueName,
  setRouteEventPath,
  setSelectedCoreISODate,
  setSelectedCoreSeats,
};

export { ChangeCancelController as ComponentUnderTest };
export default connect(mapStateToProps, mapDispatchToProps)(ChangeCancelController);
